import { GO_TO_CHANGE_DOC } from '../routes/paths';
import { Doctor } from '../store/types/prescription';
import { GET_PRESCRIPTION_BY_ID } from './constants';
import { VISIT_TYPE } from './fetchAllVisitsForPatient';
import fetchWithRefresh from './fetchWithRefresh';
import { Tool } from './pushVisit';

export interface Patient {
    profile: Profile;
    _id: string;
    uuid?: string;
}
export interface Profile {
    personal: Personal;
}
export interface Personal {
    name: string;
    phone?: Phone;
    age: Age;
    gender: string;
}
export interface Phone {
    c?: string;
    n?: string;
}
export interface Age {
    ageInMonths?: number;
    dob?: string;
}

export interface ClinicData {
    _id: string;
    city_id: string;
    name: string;
    number?: NumberEntity[] | null;
    address: Address;
    price: Price;
    location?: string[] | null;
    logo: string;
    default: boolean;
}
export interface NumberEntity {
    c: string;
    n: string;
}
export interface Address {
    line1: string;
    city: string;
    state: string;
    country: string;
    pin: string;
}

export interface Price {
    c: string;
    v: number;
}

export interface Px {
    id: string;
    visitid: string;
    patient: Patient;
    doctor: Doctor;
    tool: Tool;
    selectedClinicData?: ClinicData;
    date: string;
    type?: VISIT_TYPE;
    doc_name?: string;
}

interface PrescriptionResponse {
    status: string;
    data?: Px;
}

export default async (pxId: string): Promise<Px | undefined> => {
    const res = await fetchWithRefresh(GET_PRESCRIPTION_BY_ID(pxId));

    if (res.status === 200) {
        const result: PrescriptionResponse = await res.json();
        return result.status === 'success' ? result.data : undefined;
    } else if (res.status === 403) {
        const response = await res.json();
        if (response.code === 'DIFF') {
            alert('Multiple doctor accounts detected on your browser, please select profile');
            window.location.replace(GO_TO_CHANGE_DOC);
            return;
        }
    }
    throw new Error('unknown status code');

    return;
};
